import * as React from 'react';
import { useState } from 'react';
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Modal, Spinner } from "react-bootstrap";
import * as yup from 'yup';
import * as formik from 'formik';
import atlasApi from "../utils/atlasapi";
import Select from "react-select";

import TagSelector from "../components/TagSelector";

export interface diagProps {
	setup: object;
	onClose: (value: string) => void;
}

export default function DialogScenario(props: diagProg) {
		
	const [validated, setValidated]		= useState(false);
	const [status, setStatus]			= useState({sent:null, message:''});
	
	const { onClose, setup}				= props;
	const { Formik }					= formik;
	
	const user							= setup.user;
	const options						= setup.options;
	const selected						= setup.selected;
	const projectid						= setup.projectid;
	const versionid						= setup.versionid;
	const name							= setup.name;
	
	const handleClose = (result) => {
		setStatus({sent:null, message:''});
		onClose(selected);
		
		if(setup.onFinish){
			setup.onFinish(result);
		}
		else if(result && result.new_scenario_id){
			window.location.href = '/pages/project/'+projectid+'?scenarioid='+result.new_scenario_id;
		}
	};

	const handleSubmit = (data) => {

		setStatus({sent:false, success:false, message:'Saving...'});
		
		if(versionid)
			data = {...data, versionId:versionid};
		
		
		atlasApi.createScenario(projectid, data).then((res)=>{
			if(res.new_scenario_id){
				setStatus({sent:true, success:true, message:'Your scenario was copied'});
				//redirect without timout
				setTimeout(() => {
					handleClose({...data, ...res});
				}, 2000);
				return;
			}
			else
				setStatus({sent:true, success:false, message:'Error copying scenario'});
		}).catch((e)=>{
			setStatus({sent:true, success:false, message:'Error copying scenario'});
		});
	};
	const schema = yup.object().shape({
	  name: yup.string().min(3).required(),
	  basedOnScenarioId : yup.number().required()
	});
	
	var dV = {}
	if(options)
		dV = options.find((o)=>{return o.value == selected?.value});

	return (
		<Modal show={setup.open} onHide={handleClose} centered>
			<Modal.Header closeButton>
				<Modal.Title>Create new scenario</Modal.Title>
			</Modal.Header>
			
			<Formik validationSchema={schema} onSubmit={handleSubmit} initialValues={{ name:name, defaultValue:dV, basedOnScenarioId:selected ? selected.value : null}}>	
				{({ handleSubmit, handleChange, values, touched, errors, setFieldValue}) => (
					<Form noValidate onSubmit={handleSubmit}>

						{status.sent === null ? (
							<React.Fragment>
								<Modal.Body>
									<Row className="mb-3">
										<Form.Group as={Col} md="12" controlId="validationFormik01">
											<Form.Label>Copy from</Form.Label>
											<Select 
												name="basedOnScenarioId" 
												options={options} 
												defaultValue={values.defaultValue} 
												onChange={(sel)=>setFieldValue("basedOnScenarioId", sel.value)}  
												isSearchable={true} 
												placeholder="Select scenario" 
												isValid={touched.basedOnScenarioId && !errors.basedOnScenarioId} 
												isInvalid={errors.basedOnScenarioId}
											/>
											<Form.Control.Feedback>Looks good!</Form.Control.Feedback>
										</Form.Group>
									</Row>
									<Row className="mb-3">
										<Form.Group as={Col} md="12" controlId="validationFormik02">
											<Form.Label>New scenario name</Form.Label>
											<Form.Control type="text" name="name" placeholder="Input scenario name"   value={values.name} onChange={handleChange} isValid={touched.name && !errors.name} isInvalid={errors.name}/>
											<Form.Control.Feedback type="invalid">
												Please provide a valid scenario name.
											</Form.Control.Feedback>
										</Form.Group>
									</Row>
									<TagSelector projectid={projectid} value={{}} onChange={(v)=>{setFieldValue("tag",v)}}/>
								</Modal.Body>
								<Modal.Footer>
									<Button variant="outline-primary" onClick={handleClose}>
										Close
									</Button>
									<Button variant="primary" type="submit">Copy scenario</Button>
								</Modal.Footer>
							</React.Fragment>
						) : (
						<Modal.Body>
							<Row className="mb-3 dialog-feedback">
								<Col xs="12" className="dialog-feedback-icon text-center">
									{
									status.sent ?
										(status.success ? 
											(<i className="ri-checkbox-circle-line text-success"></i>)
											:
											(<i className="ri-error-warning-line text-warning"></i>)
										)
										:
										(<Spinner animation="border" variant="info" className="mt-5" />)
									}
								</Col>
								<Col xs="12" className="dialog-feedback-text mb-5">
									{status.message}
								</Col>
							</Row>
						</Modal.Body>	
						)}
					</Form>
				)}	
			</Formik>
		</Modal>
	);
} 